import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "price-medflex-list d-flex flex-column",
      class: _setup.isMobile ? "ga-6" : "ga-8",
      attrs: { "data-qa": "lpu_services" },
    },
    [
      _vm.isNotFound
        ? _c(_setup.PriceEmptyState, { attrs: { "empty-src": _vm.emptySrc } })
        : [
            _vm._l(_setup.groups, function (group) {
              return _c(
                "div",
                {
                  key: group.source.name,
                  staticClass: "price-medflex-list__group d-flex flex-column",
                  class: _setup.isMobile ? "ga-4" : "ga-6",
                  attrs: { "data-qa": "lpu_services_service_group" },
                },
                [
                  !_vm.hideGroupTitles
                    ? _c(
                        "h2",
                        {
                          staticClass: "text--text",
                          class: _setup.isMobile ? "text-h6" : "text-h5",
                          attrs: {
                            "data-qa": "lpu_services_service_class_name_text",
                          },
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _setup.tDynamic(group.source, "name") ||
                                  group.source.name
                              ) +
                              "\n      "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    _setup.PricesListCard,
                    { attrs: { "list-qa": "lpu_services_service_list" } },
                    _vm._l(group.services, function (service, index) {
                      return _c(_setup.PricesServiceRow, {
                        key: service.synonym_id,
                        attrs: {
                          service: service,
                          "is-striped": index % 2 === 1,
                          "is-calendar-open":
                            _setup.openedSynonymId === service.synonym_id,
                          "lpu-id": _vm.lpuId,
                          "town-timedelta": _vm.townTimedelta,
                        },
                        on: {
                          "open-calendar": _setup.onOpenCalendar,
                          "close-calendar": function ($event) {
                            _setup.openedSynonymId = null
                          },
                          "empty-schedule": _setup.onEmpty,
                          slot: _setup.onSlot,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            }),
            _vm._v(" "),
            _vm.showAllButton
              ? _c(
                  "div",
                  { staticClass: "d-flex justify-center" },
                  [
                    _c(
                      VBtn,
                      {
                        staticClass:
                          "branding-btn branding-btn--primary rounded-20 text-none text-subtitle-1",
                        attrs: {
                          depressed: "",
                          color: "primary",
                          height: "52",
                          block: _setup.isMobile,
                          "data-qa": "lpu_services_service_price_show_all",
                        },
                        on: {
                          click: function ($event) {
                            return _setup.emit("show-all")
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_setup.tStatic("Показать все услуги")) +
                            "\n      "
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }